

<template>
  <div class="custom-actions">
    <button
      class="btn btn-warning btn-micro"
      @click="onAction('view-item', rowData, rowIndex)"
      :disabled="(rowData.status === 'serverImproving') "
    >{{$t('dashboard.manage')}}</button>
  </div>
</template>

  <script>
export default {
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    itemAction (action, data, index) {
      console.log('custom-actions: ' + action, data.name, index)
    },
    onAction (action, data, index) {
      this.$router.push('/management/' + data.hosting_id)
      console.log(this.$route)
    }
  }
}
</script>

<style>
.custom-actions button.ui.button {
padding: 8px 8px;
}
.custom-actions button.ui.button > i.icon {
margin: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/data-visualisation-tab/ManageAction.vue